module.exports = __webpack_public_path__ + "static/media/undraw_blank_canvas.408b6f34.svg";